import { ReactTFC } from "../../../utils/fp/missing-ts-parts";

import { css } from "@emotion/react";

import { CSS_COLORS } from "../../../styles/styles-css-variables";
import React from "react";
import { CSS_MQ } from "../../../styles/breakpoints";

export const CarouselTip: ReactTFC<{ selectedProductsCount?: number }> = props => {
  return (
    <div
      className={props.selectedProductsCount ? `selected-${props.selectedProductsCount}` : undefined}
      css={css`
        position: absolute;

        width: 40px;
        height: 40px;

        background-color: ${CSS_COLORS.GreenWhite};

        transform: rotate(45deg);

        ${CSS_MQ.atMostSm} {
          &.selected-1 {
            left: calc(75% - 20px);
          }
        }

        left: calc(50% - 20px);
        top: calc(100% - -7px);
      `}
    />
  );
};
